import * as React from "react";
import { styled } from "@mui/system";
import MUIStepper from "@mui/material/Stepper";
import { StepperProps as StepperPropsMUI } from "@mui/material/Stepper";
export interface StepperProps extends StepperPropsMUI {
  component?: React.ElementType;
}

export const Stepper: (props: StepperProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, StepperProps>((props, ref) => (
    <MUIStepper ref={ref} {...props} />
  )),
  {
    name: "Stepper",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiStepper-root.MuiStepper-vertical .MuiStepConnector-root  .MuiStepConnector-line.MuiStepConnector-lineVertical":
    {
      borderColor: theme.palette.primary.borderDefault,
      borderLeftWidth: 2,
      marginLeft: 3
    }
}));
